import React, { useEffect } from 'react';
import Header from './landing/Header'; // Re-use header for consistency
import Footer from './landing/Footer'; // Re-use footer for consistency
import ScrollableContainer from './landing/ScrollableContainer';
import { FaComments } from 'react-icons/fa'; // Changed icon to FaComments
import './ProductsPage.css'; // Styles specific to this page
import './LandingPage.css'; // Reuse common styles like page-container, section-content etc.
import './landing/ScrollFixes.css';

function ProductsPage() {
  // Critical document structure forcing for scrolling - SAME AS LANDING PAGE
  useEffect(() => {
    // Force scrollbar display with important styles - only on html
    document.documentElement.style.cssText = `
      overflow-y: auto !important;
      overflow-x: hidden !important;
      height: auto !important;
      min-height: 100% !important;
      max-height: none !important;
      position: static !important;
      display: block !important;
    `;
    
    // Reset body styling completely with important flags - no scroll here
    document.body.style.cssText = `
      margin: 0 !important;
      padding: 0 !important;
      height: auto !important;
      min-height: 100% !important;
      display: block !important;
      overflow: hidden !important;
      position: static !important;
      background: #fff !important;
      max-height: none !important;
      width: 100% !important;
    `;
    
    document.body.classList.add('products-page-body');
    
    // Create a style element to force scrolling only on html
    const styleEl = document.createElement('style');
    styleEl.id = 'products-page-scroll-fix';
    styleEl.innerHTML = `
      html {
        overflow-y: auto !important;
        overflow-x: hidden !important;
        max-height: none !important;
        height: auto !important;
        min-height: 100% !important;
        position: static !important;
        display: block !important;
        width: 100% !important;
      }
      body {
        overflow: hidden !important;
        max-height: none !important;
        height: auto !important;
        min-height: 100% !important;
        position: static !important;
        display: block !important;
        width: 100% !important;
      }
      #root {
        min-height: 100% !important;
        height: auto !important;
        overflow: hidden !important;
        position: static !important;
        display: block !important;
        width: 100% !important;
      }
      .footer {
        position: relative !important;
        bottom: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
      }
      
      /* Remove all additional scrollbars */
      .scrollable-container, #landing-page-container, main, section {
        overflow: hidden !important;
      }
      
      /* Explicitly hide any scrollbars in header */
      .header, .header-content, .nav-menu {
        overflow: hidden !important;
        overflow-y: hidden !important;
        overflow-x: hidden !important;
      }
    `;
    document.head.appendChild(styleEl);
    
    return () => {
      document.documentElement.style.cssText = '';
      document.body.style.cssText = '';
      document.body.classList.remove('products-page-body');
      const styleElement = document.getElementById('products-page-scroll-fix');
      if (styleElement) {
        styleElement.remove();
      }
    };
  }, []);

  // Persuasive description from PRD
  const chatServeDescription = `Elevate Your Guest Experience & Streamline Operations

Transform how you connect with customers. ChatServe is the all-in-one platform designed specifically for restaurants and bars. Empower your guests to browse menus, place orders, and book tables effortlessly through a sleek digital interface. But ChatServe goes further – engage customers 24/7 with an intelligent AI-powered WebChat that answers questions, takes orders, and secures reservations via text or voice. Seamlessly integrate with Facebook and WhatsApp, or offer easy access via a simple QR code scan on your premises. Ready to reduce wait times, boost order accuracy, and build lasting customer loyalty? Discover the future of restaurant management with ChatServe.`;

  // Get viewport height for container minimum height
  const minHeight = typeof window !== 'undefined' ? `${window.innerHeight}px` : '100vh';

  return (
    <ScrollableContainer>
      <div id="landing-page-container" className="page-container products-page-container" style={{
        width: '100%',
        minHeight,
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        paddingBottom: '0',
        marginTop: '0',
        marginBottom: '0'
      }}>
        <Header />
        <main className="products-main-content" style={{
          width: '100%',
          overflow: 'hidden',
          display: 'block',
          position: 'relative',
          minHeight: 'auto',
          flex: '1 0 auto'
        }}>
          <section className="products-section">
            <div className="section-content products-section-content">
              <h1>Our Products</h1>
              <div className="product-grid">
                {/* External link to ChatServe product */}
                <a
                  href="https://staff-test.chatserve.eu/landing/"
                  className="product-card-link"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="product-card">
                    <div className="product-card-icon">
                      <FaComments size={40} />
                    </div>
                    <div className="product-card-content">
                      <h2>ChatServe</h2>
                      {/* Use pre-wrap to preserve newlines from the description */}
                      <p style={{ whiteSpace: 'pre-wrap' }}>{chatServeDescription}</p>
                    </div>
                    {/* Optional: Add a subtle indicator for clickability */}
                    <div className="product-card-cta">
                       Learn More & Get Started →
                    </div>
                  </div>
                </a>
                {/* Future products would go here as more <a> wrapped cards */}
              </div>
            </div>
          </section>
        </main>
        <Footer />
      </div>
    </ScrollableContainer>
  );
}

export default ProductsPage;